// removed by extract-text-webpack-plugin
module.exports = {"Collection":"Collection","collection":"Collection","Collection__Item":"Collection__Item","collectionItem":"Collection__Item","Collection__ItemWrapper":"Collection__ItemWrapper","collectionItemWrapper":"Collection__ItemWrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CollectionItemTransitionProvider.scss
// module id = 535
// module chunks = 0